import { useCallback, useState } from 'react';

/*
    🔥 CONTROL DE UN MODAL

    Ahorra el useState + los dos handlers en cada vista.

    Guarda además un `payload`: al abrir podés pasarle el registro que
    se va a editar, y el modal lo lee sin que la vista tenga que
    mantener un estado aparte.

        const modal = useModal();

        <button onClick={() => modal.open(usuario)}>Editar</button>

        <AppModal isOpen={modal.isOpen} onClose={modal.close} title="Editar">
            <FormUsuario data={modal.payload} />
        </AppModal>
*/

export const useModal = (initial = false) => {

    const [useIsOpen, setIsOpen] = useState(initial);
    const [usePayload, setPayload] = useState(null);

    const CB__open = useCallback((payload = null) => {
        setPayload(payload);
        setIsOpen(true);
    }, []);

    const CB__close = useCallback(() => {
        setIsOpen(false);
        // El payload se limpia después de la animación de salida
        setTimeout(() => setPayload(null), 200);
    }, []);

    const CB__toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    return { isOpen: useIsOpen, payload: usePayload, open: CB__open, close: CB__close, toggle: CB__toggle, setPayload };
};
